import React from 'react'
import styles from '../../../css/services/conServices.module.css';
function MedicalServices() {
  return (
      <div className={styles.container}>
          <div className={styles.services}>
              <div>
                  <h1>1. توفير أسعار وعروض من الشركات (Providing prices and offers from companies)</h1>
                  <p>
                      خدمة للحصول على عروض وأسعار من الشركات
                      <br/>
                      المتعاونة، مما يساعد في اتخاذ قرارات مستنيرة بناء على
                      <br/>
                      المعلومات المقدمة.
                  </p>
              </div>
              <div>
                  <h1>2. إضافة موظفين للوثيقة (Adding employees to the document)</h1>
                  <p>
                      خدمة لإضافة موظفين جدد أو تعديل بيانات الموظفين
                      <br />
                      في الوثائق والسجلات الرسمية للشركة.
                  </p>
              </div>
          </div>
      </div>
  )
}

export default MedicalServices